import React, { useEffect, useState } from 'react';
import ManualPayPalModal from '../components/manualPaypalModal';

export default function PremiumPage() {
  const [region, setRegion] = useState('IN'); // default to India
  const [price, setPrice] = useState('₹149');
  const [showPaypalModal, setShowPaypalModal] = useState(false);

  useEffect(() => {
    const detectRegion = async () => {
      try {
        const res = await fetch('https://ipapi.co/json/');
        const data = await res.json();
        const countryCode = data.country_code;
        switch (countryCode) {
          case 'IN':
            setRegion('IN');
            setPrice('₹149');
            break;
          case 'US':
            setRegion('US');
            setPrice('$5');
            break;
          default:
            setRegion('INTL');
            setPrice('$5');
        }
      } catch (err) {
        console.error('Geo detection failed', err);
        // Fallback to navigator.language
        const lang = navigator.language || '';
        if (lang.includes('en-US')) {
          setRegion('US');
          setPrice('$5');
        } else {
          setRegion('IN');
          setPrice('₹149');
        }
      }
    };
    detectRegion();
  }, []);

  const handleSubscribe = () => {
    // Replace with your actual region-specific payment URL
    /*const paymentLinks = {
      IN: 'https://your-razorpay-india-link',
      US: 'https://your-paddle-us-link',
      EU: 'https://your-lemon-europe-link',
    };
    window.location.href = paymentLinks[region] || paymentLinks['IN'];*/
    setShowPaypalModal(true);
  };

  return (
    <div className="max-w-4xl mx-auto p-6 mt-12 text-center">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">Go Premium</h1>
      <p className="text-gray-600 text-lg mb-10">Remove Ads, unlimited uploads, custom themes, and more.</p>

      {/* Benefits Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 text-left">
        <div className="bg-white border p-4 rounded shadow">
          <h3 className="font-semibold text-gray-800 mb-2">Unlimited Book Uploads</h3>
          <p className="text-gray-600 text-sm">Say goodbye to the 4-book limit on free accounts.</p>
        </div>
        <div className="bg-white border p-4 rounded shadow">
          <h3 className="font-semibold text-gray-800 mb-2">Custom Theme Uploads</h3>
          <p className="text-gray-600 text-sm">Personalize your reading experience with your own visuals and audio.</p>
        </div>
        <div className="bg-white border p-4 rounded shadow">
          <h3 className="font-semibold text-gray-800 mb-2">Remove Ads</h3>
          <p className="text-gray-600 text-sm">Get rid of annoying advertisements.</p>
        </div>
        <div className="bg-white border p-4 rounded shadow">
          <h3 className="font-semibold text-gray-800 mb-2">Unlock Premium Themes</h3>
          <p className="text-gray-600 text-sm">Access beautifully designed themes crafted by Poppyruz.</p>
        </div>
      </div>

      {/* Pricing & CTA */}
      <div className="bg-purple-100 border border-purple-300 rounded-lg p-6 inline-block">
        <h2 className="text-2xl font-bold text-purple-800 mb-2">One-Time Payment</h2>
        <p className="text-purple-700 text-xl font-semibold mb-4">{price}</p>
        <button
          onClick={handleSubscribe}
          className="bg-purple-600 text-white px-6 py-3 rounded hover:bg-purple-700 transition"
        >
          Subscribe Now
        </button>
        <p className="text-sm text-gray-500 mt-2 italic">One-time only. No hidden charges. Lifetime access.</p>
      </div>
      <ManualPayPalModal isOpen={showPaypalModal} onClose={() => setShowPaypalModal(false)} />
    </div>
  );
}
